export default {"src":"/komodo/_next/static/media/firo-logo.94ec1a01.svg","height":312,"width":882,"blurWidth":0,"blurHeight":0};